<template>
  <v-container id="project-summary" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <idc-component-bid-summary
          slug="unallocated-projects"
          :type="status"
          :statuses="bidStatuses"
          :title="title"
          :sub-header="subHeader"
          :year="year"
          unallocated
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { ManagementStatus } from '@/utilities/bid/enums/Status'

  export default Vue.extend({
    name: 'DashboardFinanceProjectsUnallocatedSummary',
    components: {
      IdcComponentBidSummary: () => import('@/components/idc/bids/Summary.vue'),
    },
    props: {
      bidStatuses: {
        type: Array,
        default: () => [16, 17, 18, 19, 20, 21, 22, 23, 24, 25],
      },
      year: {
        type: Number,
        default: () => null,
      },
    },
    data: () => ({
      status: ManagementStatus.STATUS_TYPE_LIVE,
      subHeader: 'Projects',
    }),
    computed: {
      title: vm => `Unallocated Project Summary${vm.year ? ` ${vm.year}` : ''}`,
    },
  })
</script>

<style lang="sass">
  section#project-summary
    .v-card--material
      &__heading.success
        background-color: $dark-red-colour !important
        border-color: $dark-red-colour !important
</style>
